import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import { IDS } from "../../utils/IDS";

// Thunk for getting all CARTS
export const getAllWishlist = createAsyncThunk(
    'get-all-wishlist',
    async (_, { rejectWithValue }) => {
        try {

            const response = await GET(APIS.WishList.WISHLIST);
            return response;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for Checking itme in  CART
export const checkInWishlist = createAsyncThunk(
    'check-in-wishlist',
    async (product_id, { rejectWithValue }) => {
        try {
            const response = await GET(APIS.WishList.CHECk_ITEM_IN_WISHLIST + `/${product_id}`);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for posting CART
export const postWishlist = createAsyncThunk(
    'post-wishlist',
    async ({ product_id }, { rejectWithValue }) => {
        try {
            const response = await POST(`${APIS.WishList.WISHLIST}/${product_id}`);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// Create the slice
const wishlitSlice = createSlice({
    name: "wishlist",
    initialState: {
        allWishlist: [],
        storeInFav: false,
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllWishlist.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(getAllWishlist.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.allWishlist = action.payload?.data || [];

            })
            .addCase(getAllWishlist.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;

            })

            .addCase(checkInWishlist.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(checkInWishlist.fulfilled, (state, action) => {
                state.status = 'succeeded';

                state.itemInWishlist = action.payload?.data?.is_wishlisted || false;

            })
            .addCase(checkInWishlist.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            .addCase(postWishlist.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(postWishlist.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(postWishlist.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
    },
});

export default wishlitSlice.reducer;




